import React from 'react';
import { NavLink } from 'react-router-dom';
import { useNotifications } from '../../context/NotificationContext';

const Sidebar = ({ isOpen }) => {
  const { newTicketsCount } = useNotifications();
  const menuItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/profile', icon: '👤', label: 'Profile' },
    { path: '/users', icon: '👥', label: 'Users' },
    { path: '/subscriptions', icon: '💳', label: 'Subscriptions' },
    { path: '/support', icon: '🎫', label: 'Support' },
    { path: '/packages', icon: '📮', label: 'Packages' },
    { path: '/message-templates', icon: '📝', label: 'Email Templates' },
    { path: '/email-broadcast', icon: '📧', label: 'Email Broadcast' },
    { path: '/cron-jobs', icon: '⏰', label: 'Cron Jobs' },
    { path: '/email-logs', icon: '📋', label: 'Email Logs' },
    { path: '/free-subscriptions', icon: '🎁', label: 'Free Subscriptions' },
    { path: '/app-versions', icon: '📱', label: 'App Versions' },
  ];

  return (
    <aside
      className={`fixed left-0 top-0 h-screen bg-gray-900 text-white transition-all duration-300 z-40 flex flex-col ${
        isOpen ? 'w-64' : 'w-20'
      }`}
    >
      <div className="flex items-center justify-center h-16 border-b border-gray-800 flex-shrink-0">
        <h1 className={`font-bold text-xl ${isOpen ? 'block' : 'hidden'}`}>
          Admin Panel
        </h1>
        <span className={`text-2xl ${isOpen ? 'hidden' : 'block'}`}>🎯</span>
      </div>

      <nav className="mt-8 overflow-y-auto flex-1 scrollbar-thin scrollbar-thumb-gray-700 scrollbar-track-gray-800">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center px-6 py-3 hover:bg-gray-800 transition-colors relative ${
                isActive ? 'bg-gray-800 border-l-4 border-blue-500' : ''
              }`
            }
          >
            <span className="text-2xl">{item.icon}</span>
            <span className={`ml-4 ${isOpen ? 'block' : 'hidden'}`}>
              {item.label}
            </span>
            {item.path === '/support' && newTicketsCount > 0 && (
              <span className={`absolute ${isOpen ? 'right-6' : 'top-2 right-2'} bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center`}>
                {newTicketsCount > 9 ? '9+' : newTicketsCount}
              </span>
            )}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
